import { useState } from 'react';

export default function useOpsDirectoryNavigation() {
  const [routes, setRoutes] = useState([]);
  const open = route => setRoutes(previous => {
    const index = previous.findIndex(item => item.key === route.key);
    return index < 0 ? [...previous, route] : [...previous.slice(0, index), { ...previous[index], ...route }];
  });
  return {
    routes,
    isList: routes.length === 0,
    openUser: (id, tab = 'profile') => open({ key: `user:${id}`, type: 'user', id, tab }),
    openOrganization: (user, tab = 'information') => open({
      key: `organization:${user.organization_id || user.id}`, type: 'organization', user, tab,
    }),
    setTab: (key, tab) => setRoutes(previous => previous.map(route => route.key === key ? { ...route, tab } : route)),
    back: () => setRoutes(previous => previous.slice(0, -1)),
    backToUsers: () => setRoutes([]),
  };
}
